import type { Role } from "@project/common";
import type { ComponentType } from "react";
import type { RoutePath } from "../App";

export enum MenuType {
  Single = "Single",
  Nested = "Nested",
  Divider = "Divider",
}

export type SingleMenuOption = {
  type: MenuType.Single;
  title: string;
  hideOnMobile?: boolean;
  Icon?: ComponentType;
  to: RoutePath;
  params?: object;
  role?: Role;
  search?: object;
  visible?: boolean;
};

export type NestedMenuOption = {
  type: MenuType.Nested;
  title: string;
  hideOnMobile?: boolean;
  Icon?: ComponentType;
  options: SingleMenuOption[];
  prefix: string;
  role?: Role;
  search?: object;
  visible?: boolean;
};

type MenuDivider = {
  type: MenuType.Divider;
  visible?: boolean;
  hideOnMobile?: boolean;
};

export type MenuOption = MenuDivider | NestedMenuOption | SingleMenuOption;

export interface NavMenuOptions {
  items: MenuOption[];
}
